import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button } from '@3plearning/react-components';
import css from './modal.scss';

/**
 * Modal component
 * Displays content and buttons (if provided)
 */
const Modal = ({ message, onClose }) => (
    <div className={css.component}>
        <div className={css.content}>
            {message.title && <h2>{message.title}</h2>}
            {message.content}
            {message.buttons ? (
                <div className={css.actions}>{
                    message.buttons.map((item) => {
                        // determine required props for Button component
                        const styleProps = {};
                        ['primary', 'danger', 'info', 'disabled'].forEach((className) => {
                            if (item[className]) {
                                styleProps[className] = true;
                            }
                        });
                        return (
                            <Button
                                {...styleProps}
                                key={_.uniqueId()}
                                text={item.title}
                                onClick={() => {
                                    if (item.handler) {
                                        item.handler();
                                    } else {
                                        onClose();
                                    }
                                }}
                            />
                        );
                    })
                }</div>) : null}
        </div>
    </div>
);

Modal.propTypes = {
    onClose: PropTypes.func,
    message: PropTypes.shape({
        id: PropTypes.number,
        content: PropTypes.element,
        buttons: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            handler: PropTypes.func,
            primary: PropTypes.bool,
            danger: PropTypes.bool,
            info: PropTypes.bool,
            disabled: PropTypes.bool
        }))
    })
};

export default styleable(css)(Modal);



// WEBPACK FOOTER //
// ./components/modal/modal/modal.js